<div class="tw:-m-2 tw:flex tw:flex-wrap">
  <div class="tw:w-full tw:flex-none tw:p-2">
    <div class="tab-title tw:-m-2 tw:flex tw:flex-wrap tw:justify-center">
      @for (item of tabList; track item) {
        <div
          (click)="itemSelectionHandler(item)"
          [class.tab-selected]="selectedItem === item"
          class="tab-container tw:flex-none tw:p-2 tw:pb-1"
        >
          {{ item }}
        </div>
      }
    </div>
  </div>
  <div class="tw:w-full tw:flex-none tw:p-2">
    <div class="tw:-m-2 tw:flex tw:flex-wrap tw:justify-center">
      <div class="tab-content">
        <ng-content select="[tab-content]"></ng-content>
      </div>
    </div>
  </div>
</div>
